import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'Components/Button';
import { Checkbox } from 'Components/Form';
import HorseRacingBetSlipInfoItem from './BetSlipInfoItem';
import History from 'Store/history';
import { openModal } from 'Store/actions';
import { classnames } from 'Utils/classnames';
import EnvironmentManager from 'Utils/environmentManager';
import { playTJKCoupon } from 'Store/actions/horseRacing';
import { decimalFormatterLast } from 'Utils/decimalFormatter';
import { toggleHRBetSlip } from 'Store/actions/horseRacing';
import { saveTjkCoupon } from 'Store/actions/horseRacing/couponActions';
import inputMinMaxValidatorHorseRacing from 'Utils/inputMinMaxValidatorHorseRacing';
import {
  setHRBetslipAllVariation,
  setHRBetslipCouponCount,
  setHRBetslipMultiplier,
  toggleSystemModal
} from 'Store/actions/horseRacing/betSlipActions';
import { withMixpanel } from 'Utils/mixpanel';
import { RUNWAY_TYPES } from 'Utils/horseRacesNameMapper';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';
import { oddFormatter } from 'Utils/decimalFormatter';
import Predicta from 'Components/Predicta';
import { useHRBetslipSystem } from 'Utils/hooks/useHRBetslipSystem';

const HorseRacingBetSlipFooter = ({ selectedInfos, isBetslipvalid, verify, isLocaleValid, mixpanel }) => {
  const { allVariation, couponCount, multiplier, system, fixedOddMultiplier } = useSelector(state => state.horseRacing?.betSlip?.footerData);
  const play = useSelector(state => state.horseRacing?.betSlip?.play);
  const { isAuthenticated } = useSelector(state => state.auth);
  const verifyData = verify?.data?.body || {};
  const verifyErrorData = verify?.error?.extras || {};
  const hippodromesInfo = useSelector(state => state.horseRacing.hippodromesInfo);
  const selectedHippodrome = hippodromesInfo?.data?.find(h => h.cardId ? h.cardId === hippodromesInfo.selectedHippodromeId : h.akey === hippodromesInfo.selectedHippodromeId);
  const availableBets = useSelector(state => state.horseRacing.hippodromeAvailableBets);
  const selectedBet = availableBets?.data.find(a => a.id === availableBets.selectedBetTypeId);
  const selectedHorseLegs = useSelector(state => state.horseRacing.betSlip?.legs);
  const isLoadedFromCouponConfig = useSelector(state => state.horseRacing.betSlip?.isLoadedFromCouponConfig);
  const fromAuthorData = useSelector(state => state?.horseRacing?.authorComments?.playedData);
  const programType = useSelector(state => state?.horseRacing?.allHippodromes?.programType);
  const isFixedOdd = programType === PROGRAM_TYPES.FIXED;
  const [state, setState] = useState({ couponCount: couponCount || 1, multiplier: isFixedOdd ? fixedOddMultiplier : multiplier || 1, });
  const betSlip = useSelector(state => state.horseRacing.betSlip);
  const { combinedHorses } = betSlip;
  const dispatch = useDispatch();
  const maxHorseCount = Number(EnvironmentManager.getMessageText({ key: 'v1.general.parlay_odd_limit_count' })) || 4;
  const { systemSelected } = useHRBetslipSystem();
  const systemAllowed = verifyData?.systemAllowed || verifyErrorData?.systemAllowed;

  const deleteIconArea = <i
    className="bly bly-bin bly-size22 horse-racing-betslip__header__delete"
    onClick={ () =>
      dispatch(openModal('tjkCouponInformationModal', {
        successCallback: () => {
          dispatch(toggleHRBetSlip(false));
        },
        text: 'Kuponundaki seçimleri silmek istediğine emin misin?'
      }))
    }
  />;

  const saveIconArea = <i
    className={ 'bly bly-save-stroke bly-size22 betslip__header__save' }
    onClick={ () => {
      if (isAuthenticated) {
        mixpanel.track('Save Coupon', {
          Hippodrome: selectedHippodrome?.city,
          'Bet Type': selectedBet?.description,
          'Bet Amount': state?.multiplier,
          'Total Bet Amount': verifyData?.cost
        });
        if (isBetslipvalid) {
          dispatch(saveTjkCoupon());
        }

      } else {
        History.push('/giris-yap');
      }
    }
    }
  />;

  const onPlayClick = async () => {
    dispatch(playTJKCoupon());
    const betDetail = selectedHorseLegs.map((selectedLeg, index) => {
      if (selectedLeg && selectedLeg !== undefined) {
        return {
          'Coupon Race Number': selectedInfos?.legsData?.findIndex(item => item?.legNo === index) + 1,
          'Hipoddrome Race Number': index,
          'Track List': RUNWAY_TYPES[selectedInfos?.legsData?.find(item => item?.legNo === index)?.runwayType],
          'Horse Detail': selectedLeg.map(selectedHorse => {
            return {
              'Horse Kit Number': selectedHorse?.horseNo,
              'Horse Name': selectedHorse?.name,
              AGF: selectedHorse?.agf,
              'Jockey Name': selectedHorse?.tag?.jokeyDetail?.name,
              'Handicap Point': selectedHorse?.tag?.handicap,
              'Rest Days Count': selectedHorse?.tag?.kgs,
              Lane: selectedHorse?.tag?.boxNo,
              Age: selectedHorse?.tag?.age,
              'Weight (kg)': selectedHorse?.tag?.weight,
              'Last Races': selectedHorse?.tag?.lastRaceRanks,
              'Father Name': selectedHorse?.origin?.father?.name,
              'Mother Name': selectedHorse?.origin?.mother?.name,
              Jewelry: selectedHorse?.accessory,
              Stablemate: selectedHorse?.stablemateGroupInfo > 0,
              'Stablemate Name': selectedHorse?.stablemateGroupInfo > 0 ? selectedLeg?.find(item => item?.stablemateGroupInfo === selectedHorse?.stablemateGroupInfo && item.key !== selectedHorse?.key)?.name : null,
              Owner: selectedHorse?.ownership?.owner?.name,
              Trainer: selectedHorse?.ownership?.coach?.name,
              Breeder: selectedHorse?.ownership?.steward?.name,
              'Horse Key': selectedHorse?.key,
              Odd: selectedHorse?.probableGain,
            };
          })
        };
      }
    });
    const mixpanelEvents = {
      Hippodrome: selectedHippodrome?.city,
      'Bet Type': selectedBet?.description,
      'Bet Type Order Selection': selectedInfos?.selectedRaceNumber,
      'Bet Amount': multiplier,
      'Multiple Coupon Flag': couponCount > 1,
      'Multiple Coupon Count': couponCount,
      'Total Bet Amount': verifyData?.cost,
      'Horse Count': selectedHorseLegs?.flat()?.filter(sh => sh)?.map(h => h).length,
      'Race Number Count': selectedInfos?.legsData?.length,
      'Event First Start Time': `${selectedHippodrome?.raceDate}T${selectedHippodrome?.startTime}:00Z`,
      Rebet: isLoadedFromCouponConfig?.rebet ? isLoadedFromCouponConfig?.rebet : false,
      'Rebet Type': isLoadedFromCouponConfig?.rebetType ? isLoadedFromCouponConfig?.rebetType : '-',
      'Saved Coupon': isLoadedFromCouponConfig?.savedCoupon ? isLoadedFromCouponConfig?.savedCoupon : false,
      'Variation Switch Button Status': allVariation,
      'Bet Detail': betDetail.filter(b => b),
      'Writer Flag': fromAuthorData?.isFromAuthor || false,
      'Writer Name': fromAuthorData?.name || '-',
      'Writer Selection Coupon': fromAuthorData?.couponType || '-',
      'Game Type': isFixedOdd ? 'Sabit İhtimalli' : 'Müşterek',
      'System Bet': systemSelected,
      // 'User Horse Racing Bet Count': 'incremental', // user.set
      // 'User Horse Racing Bet Amount': incremental, // user.set
      // 'User Horse Racing Pre Bet Amount': incremental, // user.set
      // 'Last Place Horse Racing Bet Time': date //  user.set
    };
    mixpanel.track('TJK Complete Place Bet', mixpanelEvents);
    if (isAuthenticated) {
      mixpanel.people.increment('User Horse Racing Bet Amount', verifyData?.cost);
      mixpanel.people.increment('User Horse Racing Pre Bet Amount', verifyData?.cost);
      mixpanel.people.increment('User Horse Racing Bet Count');
    }
  };

  const onChange = e => {
    const numberRegex = /^[0-9\b]+$/;
    const isValid = e.target.value !== '' ? numberRegex.test(e.target.value) : true;
    const { id, value } = e.target;

    if (isValid) {
      setState(prev => ({
        ...prev,
        [id]: value,
      }));
    }
  };

  const onBlur = e => {
    const { id, value } = e.target;

    if (value === '') {
      return;
    }

    const modifiedValue = inputMinMaxValidatorHorseRacing({
      id,
      value,
    }, isFixedOdd, systemSelected);

    setState(prev => ({
      ...prev,
      [id]: modifiedValue.value,
    }));

    if (id === 'multiplier') {
      dispatch(setHRBetslipMultiplier(modifiedValue.value));
    } else {
      dispatch(setHRBetslipCouponCount(modifiedValue.value));
    }
  };

  const onFocus = e => {
    e.target.value = '';
  };

  const onSystemClick = source => {
    dispatch(toggleSystemModal(true));
    if (systemAllowed) {
      mixpanel.track('TJK Click System Field on Betslip', {
        BetCount: combinedHorses?.length || 0,
        CurrentSystemValue: system?.join('-')
      });
    } else {
      mixpanel.track('TJK View Exceed Bet Count Info', {
        BetCount: combinedHorses?.length || 0,
        Source: source
      });
    }
  };

  useEffect(() => {
    if (couponCount !== state.couponCount) {
      setState(prev => ({
        ...prev,
        couponCount: couponCount,
      }));
    }
    if (multiplier !== state.multiplier) {
      setState(prev => ({
        ...prev,
        multiplier: multiplier,
      }));
    }
  }, [couponCount, multiplier]);

  useEffect(() => {
    setState(prev => ({
      ...prev,
      multiplier: isFixedOdd ? fixedOddMultiplier : multiplier
    }));
  }, [isFixedOdd, fixedOddMultiplier, multiplier]);

  const renderMessage = () => {

    const _class = classnames({
      'tjk-betslip-verify-message': true,
      'tjk-betslip-verify-message--hide': isLocaleValid && !verify?.error
    });
    const errorText = EnvironmentManager.getMessageText({ key: 'description_tjk_betslip_' + selectedInfos?.selectedBet?.id }) || 'Lütfen her yarışa en az bir at ekleyiniz.';

    let errorMessage = EnvironmentManager.getMessageText({ key: verify?.error?.domain + verify?.error?.code }) || verify?.error?.message;

    if (verify?.error?.domain === 'tjk-mobile-bff' && verify?.error?.code === 1001) {
      errorMessage = EnvironmentManager.getMessageText({ key: 'description_tjk_betslip_' + selectedInfos?.selectedBet?.id });
    }
    if (verify?.error?.domain === 'tjk-mobile-bff' && verify?.error?.code === 1002) {
      const maxPrice = +EnvironmentManager.getMessageText({ key: 'tjkapp_tjk_max_coupon_total' }) || 6500;
      errorMessage = EnvironmentManager.getMessageText({ key: verify?.error?.domain + verify?.error?.code }).replace('%@', maxPrice);
    }
    if (verify?.error?.domain === 'tjk-mobile-bff' && verify?.error?.code === 1003) {
      const minPrice = +EnvironmentManager.getMessageText({ key: 'tjkapp_tjk_min_coupon_total' }) || 10;
      errorMessage = EnvironmentManager.getMessageText({ key: verify?.error?.domain + verify?.error?.code }).replace('%@', minPrice);
    }
    if (verify?.error?.domain === 'tjk-mobile-bff' && verify?.error?.code === 1018) {
      errorMessage = EnvironmentManager.getMessageText({ key: verify?.error?.domain + verify?.error?.code }).replace('%@', decimalFormatterLast(verify?.error?.extras?.maxCouponCost || 0));
    }

    const errText = !isLocaleValid ? errorText : errorMessage || 'Kupon kontrol edilirken bir hata oluştu.';


    return (
      <div className={ _class }>
        <i className="bly bly-info-circle-inverse bly-red bly-size24"/>
        <span className='err-text'>{ errText }</span>
      </div>
    );
  };

  const showSystemInput = (EnvironmentManager.getMessageText({ key: 'v1.system.visible' }) === 'true' && isFixedOdd);

  return (
    <div className="horse-racing-betslip__footer__fixed">
      { renderMessage() }
      {
        isFixedOdd && <>
          <Predicta/>
          <div className="horse-count-message">
            <div className="description">
              { maxHorseCount === combinedHorses?.length ? 'Maksimum Sınıra Ulaştın' : <>{ combinedHorses?.length } Bahis <span>Ekledin</span></> }
            </div>
            <div className="count">{ combinedHorses?.length }<span>/{ maxHorseCount }</span></div>
          </div>

        </>
      }
      {
        isFixedOdd && combinedHorses?.some(h => h?.horse?.propositionInfo?.spbah === true)
        && <div className="extra-message">
          { EnvironmentManager.getMessageText({ key: 'v1.betslip_fixodd.sp_info' }) }
        </div>
      }

      <div className="horse-racing-betslip__footer">
        <div className="horse-racing-betslip__footer__bottom">
          <div className="horse-racing-betslip__footer__bottom__utils">
            { deleteIconArea }
            { (((isFixedOdd && EnvironmentManager.getMessageText({ key: 'tjkapp_v1.bulletin_fixodd.couponSaveAvailable' }) === 'true')) || (!isFixedOdd)) && saveIconArea }
          </div>
          <Button
            title={ 'OYNA' }
            className="btn--primary horse-racing-betslip__footer__bottom__play-button"
            onClick={ onPlayClick }
            disabled={ !isBetslipvalid || play?.isLoading }
          >
            OYNA
          </Button>
        </div>
        <div className="horse-racing-betslip__footer__selections">

          <HorseRacingBetSlipInfoItem
            couponAmount
            label={ state.couponCount > 1 ? `${state.couponCount} Kupon Tutarı` : 'Kupon Tutarı' }
            value={ decimalFormatterLast((state.couponCount || 1) * (verifyData?.cost || verifyErrorData?.cost || 0)) + ' TL' }/>

          <HorseRacingBetSlipInfoItem
            id="multiplier"
            label="Misli"
            value={ state.multiplier }
            type={ 'input' }
            onFocus={ onFocus }
            onBlur={ onBlur }
            onChange={ onChange }
            inputMaxLength={ 5 }
          />

          <HorseRacingBetSlipInfoItem
            label={ !isFixedOdd ? 'Toplam Kolon Sayısı' : 'Toplam Oran' }
            value={ (() => {
              if (!isFixedOdd) {
                return verifyData?.column || verifyErrorData?.column || 0;
              }

              if (combinedHorses.length === 0) {
                return '-';
              }

              if (combinedHorses.some(h => h?.horse?.propositionInfo?.spbah)) {
                return 'K.O';
              }

              const totalOdd = verify?.error
                ? verify?.error?.extras?.fixedOddVerifyResponse?.totalOdd
                : verifyData?.fixedOddVerifyResponse?.totalOdd;

              return oddFormatter(totalOdd) || '-';
            })() }/>

          {
            showSystemInput
            && <HorseRacingBetSlipInfoItem
              className={ 'system' }
              disabled={ !systemAllowed }
              onInfoClick={ systemAllowed ? null : () =>  onSystemClick('Info Icon') }
              type={ 'clickable' } label="Sistem"
              value={ system?.length > 4 ? `${system?.slice(0, 2)?.join('-')}...`  : system?.join('-') }
              onClick={ () =>  onSystemClick('System Field') }/>
          }

          {
            !combinedHorses?.some(h => h?.horse?.propositionInfo?.spbah) && isFixedOdd
            && <HorseRacingBetSlipInfoItem
              label="Maks. Kazanç"
              value={ `${(() => {
                const errorAmount = verify?.error?.extras?.fixedOddVerifyResponse?.expectedWinAmount;
                const dataAmount = verify?.data?.body?.fixedOddVerifyResponse?.expectedWinAmount;

                if (errorAmount) {
                  return decimalFormatterLast(errorAmount);
                } else if (dataAmount) {
                  return decimalFormatterLast(dataAmount);
                } else {
                  return '0';
                }
              })()} TL` }/>
          }

          <HorseRacingBetSlipInfoItem
            id="couponCount"
            label="Kupon Adedi"
            value={ state.couponCount }
            type={ 'input' }
            onFocus={ onFocus }
            onBlur={ onBlur }
            onChange={ onChange }
          />


        </div>

        <div className={ classnames({
          'horse-racing-betslip__footer__all-variation': true,
          'horse-racing-betslip__footer__all-variation--hide': !selectedInfos?.selectedBet?.isCombinationActive
        }) }>
          <Checkbox
            className='switch'
            checked={ allVariation }
            onChange={ () => {
              dispatch(setHRBetslipAllVariation(!allVariation));
            } }
          />
          <div className='horse-racing-betslip__footer__all-variation--text'>Komple - Tüm Varyasyonları Seç</div>
        </div>
      </div>
    </div>
  );
};

HorseRacingBetSlipFooter.propTypes = {
  selectedInfos: PropTypes.object,
  isBetslipvalid: PropTypes.bool,
  legs: PropTypes.array,
  verify: PropTypes.object,
  isLocaleValid: PropTypes.bool,
  mixpanel: PropTypes.object
};

export default withMixpanel(HorseRacingBetSlipFooter);
